import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight, CheckCircle2 } from 'lucide-react';

const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] }
    }
};

const StartupsPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="pt-24 min-h-screen">
            <section className="py-20 px-6 max-w-7xl mx-auto">
                <motion.div initial="hidden" animate="visible" variants={fadeInUp} className="max-w-4xl">
                    <p className="text-[#FF5A1F] text-sm font-semibold tracking-[0.15em] uppercase mb-6">
                        High-Growth Startups
                    </p>
                    <h1 className="text-4xl md:text-6xl font-bold text-white mb-8 tracking-[-0.03em] font-sans uppercase leading-[1.05]">
                        Secure Funding & Talent with a World-Class Presence.
                    </h1>
                    <p className="text-lg md:text-xl text-[#A0A0A0] max-w-2xl leading-relaxed mb-12">
                        Startups move fast. We build scalable, high-impact web infrastructure that looks like you've already raised your Series B—attracting top talent, securing investment, and building immediate market authority.
                    </p>
                    <button
                        onClick={() => navigate("/strategy")}
                        className="cta-premium px-8 py-4 text-white font-semibold rounded-[20px] inline-flex items-center gap-2"
                    >
                        Scale Your Startup <ArrowUpRight className="w-5 h-5" />
                    </button>
                </motion.div>
            </section>

            <section className="py-20 px-6 section-elevated">
                <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center">
                    <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
                        <h2 className="text-3xl font-bold text-white mb-6 uppercase tracking-tight">How We Launch Startups</h2>
                        <ul className="space-y-6">
                            {[
                                "Rapid Deployment: We move at your speed without sacrificing quality.",
                                "Scalable CMS: Infrastructure that grows seamlessly as you scale.",
                                "Premium Aesthetics: Look trustworthy, verified, and established from day one.",
                                "Investor-Ready Flow: Highlighting the vision and market opportunity."
                            ].map((item, i) => (
                                <li key={i} className="flex items-start gap-4">
                                    <CheckCircle2 className="w-6 h-6 text-[#FF5A1F] flex-shrink-0" />
                                    <span className="text-[#A0A0A0]">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </motion.div>
                    <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
                        <div className="aspect-square rounded-[24px] overflow-hidden border border-white/[0.04]">
                            <img src="https://images.pexels.com/photos/811587/pexels-photo-811587.jpeg?auto=compress&cs=tinysrgb&w=800" alt="Startup Office" className="w-full h-full object-cover img-bw-premium hover:filter-none transition-all duration-700" />
                        </div>
                    </motion.div>
                </div>
            </section>
        </main>
    );
};

export default StartupsPage;
